module.exports = __webpack_public_path__ + "static/media/upload-from-sample-library.5b07d6bc.png";